import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime"; // Formik

import { useFormikContext } from 'formik'; // Elements

import Label from '../elements/Label';
import Error from '../elements/Error';
import useFormDuuf from '../useFormDuuf';

var ConsentField = function ConsentField(_ref) {
  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? {} : _ref$formik,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      fieldId = _ref.fieldId,
      data = _ref.data;

  var _useFormDuuf = useFormDuuf(),
      privacyUrl = _useFormDuuf.privacyUrl,
      privacyUrlPlacement = _useFormDuuf.privacyUrlPlacement;

  var _useFormikContext = useFormikContext(),
      handleChange = _useFormikContext.handleChange,
      handleBlur = _useFormikContext.handleBlur,
      values = _useFormikContext.values;

  var type = data.type.toLowerCase();
  return _jsxs("div", {
    className: "form-duuf-group form-duuf-group-".concat(type).concat(data.cssClass ? " ".concat(data.cssClass) : ''),
    children: [_jsx(Label, {
      fieldId: fieldId,
      data: data
    }), _jsx(Error, {
      fieldId: fieldId,
      data: data,
      hasError: hasError,
      formik: formik
    }), _jsxs("div", {
      className: "d-flex align-items-center flex items-center",
      children: [_jsx("input", {
        type: "checkbox",
        className: "form-duuf-checkbox form-duuf-checkbox-".concat(type),
        id: fieldId,
        name: fieldId,
        placeholder: data.placeholder,
        onBlur: handleBlur,
        onChange: function onChange(event) {
          handleChange({
            target: {
              name: event.target.name,
              value: !values[fieldId]
            }
          });
        },
        value: values[fieldId],
        checked: values[fieldId]
      }), privacyUrl && _jsx("span", {
        dangerouslySetInnerHTML: {
          __html: "".concat(data.checkboxLabel.replace(privacyUrlPlacement ? privacyUrlPlacement : data.checkboxLabel, "<a\n                target=\"_blank\"\n                rel=\"noreferrer noopener\"\n                href=\"".concat(privacyUrl, "\"\n                class=\"form-duuf-checkbox-label form-duuf-checkbox-").concat(type, "\"\n              >").concat(privacyUrlPlacement ? privacyUrlPlacement : data.checkboxLabel, "</a>")))
        }
      }), !privacyUrl && _jsx("label", {
        htmlFor: fieldId,
        className: "form-duuf-checkbox-label form-duuf-checkbox-".concat(data.type),
        dangerouslySetInnerHTML: {
          __html: data.checkboxLabel
        }
      })]
    })]
  });
};

export default ConsentField;